import type { CSSValueWithLength } from '../../styles';
import type { ImagePreviewProps as ImagePreviewNewProps } from './ImagePreview';

export interface OldImagePreviewProps extends Omit<ImagePreviewNewProps, 'radius' | 'status'> {
  /** @deprecated radius를 대신 사용해주세요. */
  borderRadius?: CSSValueWithLength;
  /** @deprecated status를 대신 사용해주세요. */
  error?: boolean;
}

export function convertOldImagePreviewProps(props: OldImagePreviewProps): ImagePreviewNewProps {
  const { borderRadius, error, ...restProps } = props;

  return {
    ...restProps,
    radius: borderRadius,
    status: error ? 'error' : undefined,
  };
}
